



















































































import Vue from "vue";
import VCAMenu from "@/components/VCAMenu.vue";
  
export default Vue.extend({
  name: "VCAGameplayElements",
  components: {
    VCAMenu
  }
});
